import { render, staticRenderFns } from "./assemble.vue?vue&type=template&id=a84fb6c2&scoped=true&"
import script from "./assemble.vue?vue&type=script&lang=js&"
export * from "./assemble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84fb6c2",
  null
  
)

export default component.exports